module.exports = __webpack_public_path__ + "ae8c12f4a637fbe374e060ce683ca44a.svg";